import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import VueMeta from 'vue-meta'

Vue.use(VueRouter)
Vue.use(VueMeta)

const mode = 'history'

const router = new VueRouter({
  mode,
  routes
})

export default router
